import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress benign ResizeObserver loop warning that CRA's dev overlay escalates
// into a full-screen red error. Harmless; see github.com/facebook/create-react-app/issues/11831
const RO_MSG = "ResizeObserver loop";
window.addEventListener("error", (e) => {
    if (e.message && e.message.startsWith(RO_MSG)) {
        e.stopImmediatePropagation();
    }
});
window.addEventListener("unhandledrejection", (e) => {
    if (e.reason?.message && e.reason.message.startsWith(RO_MSG)) {
        e.stopImmediatePropagation();
    }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
